
<template>
  <fieldset :class="`tcu-results-filter__list-set tcu-results-filter__list-${id}`">

    <!-- Button Toggle for Mobile -->
    <button v-if="sharedState.isMobile" :class="{ '_is-open': privateState.accordionOpen }" @click="toggleAccordion" :tabindex="sharedState.filterOpen ? '0' : '-1'">
      {{ name }}
      <img width="15" height="9" alt="Open Accordion" src="data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='15px' height='9px' viewBox='0 0 27 17' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Eslider arrow copy 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Program-D-Math' transform='translate(-1039.000000, -3726.000000)' fill='%234D4D4A' stroke='%234D4D4A' stroke-width='1.96'%3E%3Cg id='slider-arrow' transform='translate(1052.500000, 3734.000000) rotate(-90.000000) translate(-1052.500000, -3734.000000) translate(1044.500000, 3721.500000)'%3E%3Cpath d='M13.5324837,24.8310811 C13.312616,24.8310811 13.09215,24.7563214 12.9189481,24.6054125 L0.519904875,13.8072257 C0.189654598,13.5193037 0,13.0724132 0,12.5810559 C0,12.0896987 0.189654598,11.6428081 0.519904875,11.3548861 L12.9189481,0.556699337 C13.2803089,0.241541468 13.8483753,0.258772321 14.1873006,0.594496048 C14.526226,0.930497691 14.5079784,1.45826206 14.1463185,1.77314201 L2.68089039,11.7586995 C2.16936142,12.2039226 2.16936142,12.9581893 2.68089039,13.4034123 L14.1463185,23.3892477 C14.5079784,23.7038498 14.526226,24.2316141 14.1873006,24.5676158 C14.0108082,24.7427035 13.7717955,24.8310811 13.5324837,24.8310811' id='Fill-1'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A" class="tcu-down-arrow">
    </button>
    <!-- Regular Label on larger sizes -->
    <legend v-else>{{ name }}</legend>

    <div class="tcu-results-filter__list-wrapper" :class="{ '_is-open': privateState.accordionOpen}" v-show="privateState.accordionOpen">
      <div v-for="(item, index) in list" :key="index">
        <input type="checkbox" :id="`${id}-${item.id}`" :name="id" :value="item.id" v-model="privateState.checkedList" :tabindex="sharedState.filterOpen ? '0' : '-1'">
        <label :for="`${id}-${item.id}`">{{ item.displayName }}</label>
      </div>
      <!-- Show All -->
      <div class="tcu-results-filter__show-all">
        <input type="checkbox" :id="`${id}-all`" :name="id" value="all" v-model="privateState.showAll" :tabindex="sharedState.filterOpen ? '0' : '-1'">
        <label :for="`${id}-all`">Show All</label>
      </div>
    </div>

  </fieldset>
</template>
<script>
import store from '../store';
import { EventBus } from '../events';
import { sortAlpha } from "../helpers";

export default {
  data() {
    return {
      sharedState: store,
      privateState: {
        accordionOpen: true,
        showAll: true,
        checkedList: [],
      }
    };
  },
  props: {
    list: Array,
    name: String,
    id: String,
  },
  watch: {
    "sharedState.selectedFilters": function() {
      if (this.sharedState.selectedFilters[this.id]) {
        this.privateState.checkedList = this.sharedState.selectedFilters[this.id];
      }
    },

  },
  mounted: function(){
    // If filters were already selected in global state
    if (this.sharedState.selectedFilters[this.id]) {
      this.privateState.checkedList = this.sharedState.selectedFilters[this.id];
    }
  },
  created: function(){
    // Close filter set if we're on mobile
    if (this.sharedState.isMobile) {
      this.privateState.accordionOpen = false;
    }
  },
  watch: {
    "privateState.checkedList": function(newVal, oldVal) {
      if (newVal.length > 0) {
        // If a checkbox is selected, uncheck "Show All"
        this.privateState.showAll = false;
      } else {
        this.privateState.showAll = true;
      }
      this.emitGlobalFilterChange(newVal);
    },
    "privateState.showAll": function(newVal, oldVal) {
      if(newVal == true){
        // If "Show All" is selected, uncheck the other filters
        this.privateState.checkedList = [];
      }
    },
    "sharedState.filterOpen": function(newVal, oldVal) {
      // Close filter set when the filter menu is closed on mobile
      if(!newVal && this.sharedState.isMobile) {
        this.privateState.accordionOpen = false;
      }
    },
    "sharedState.isMobile": function(newVal, oldVal) {
      // If we're on mobile, close the accordions
      if(newVal) {
        this.privateState.accordionOpen = false;
      } else {
        this.privateState.accordionOpen = true;
      }
    },
  },
  methods: {
    /**
     * Toggle the accordion open status if we're on mobile
     */
    toggleAccordion: function(){
      if (!this.sharedState.isMobile) { return; }
      this.privateState.accordionOpen = !this.privateState.accordionOpen;
    },
    emitGlobalFilterChange: function(array){
      EventBus.$emit('filterChange', {
        id: this.id,
        filters: array,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FilterSet.vue